import { Pipe } from "@angular/core";
declare const moment;

@Pipe({
  name: "moment",
  pure: false
})
export class MomentPipe {
  constructor() {}

  transform(date: string, format: string) {
    return moment(date).format(format);
  }
}
